const state = {
  type: "",
  message: ""
};

const mutations = {
  success(state, message) {
    state.type = "success";
    state.message = message;
  },
  error(state, message) {
    state.type = "error";
    state.message = message;
  },
  clear(state) {
    state.type = "";
    state.message = "";
  }
};

const actions = {
  success({ commit }, message) {
    commit("success", message);
  },
  error({ commit }, message) {
    commit("error", message);
  },
  clear({ commit }) {
    commit("clear");
  }
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
